export default __webpack_public_path__ + "static/media/staking.43dbfa21.png";